import { storage } from './storage'

const TOKEN_KEY = 'device_token'
const DEVICE_ID_KEY = 'device_id'
const FAMILY_ID_KEY = 'family_id'
const DEVICE_NAME_KEY = 'device_name'

function uuid(): string {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID()
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
  })
}

export interface DeviceSession {
  deviceId: string
  token: string | null
  familyId: string | null
  deviceName: string | null
}

export const device = {
  init(): DeviceSession {
    let id = storage.get<string>(DEVICE_ID_KEY)
    if (!id) {
      id = uuid()
      storage.set(DEVICE_ID_KEY, id)
    }
    return {
      deviceId: id,
      token: storage.get<string>(TOKEN_KEY),
      familyId: storage.get<string>(FAMILY_ID_KEY),
      deviceName: storage.get<string>(DEVICE_NAME_KEY),
    }
  },

  setSession(input: { deviceId: string; token: string; familyId: string; deviceName: string }) {
    storage.set(DEVICE_ID_KEY, input.deviceId)
    storage.set(TOKEN_KEY, input.token)
    storage.set(FAMILY_ID_KEY, input.familyId)
    storage.set(DEVICE_NAME_KEY, input.deviceName)
  },

  setDeviceName(name: string) {
    storage.set(DEVICE_NAME_KEY, name)
  },

  getToken(): string | null {
    return storage.get<string>(TOKEN_KEY)
  },

  getFamilyId(): string | null {
    return storage.get<string>(FAMILY_ID_KEY)
  },

  getDeviceId(): string | null {
    return storage.get<string>(DEVICE_ID_KEY)
  },

  getDeviceName(): string {
    return storage.get<string>(DEVICE_NAME_KEY) || ''
  },

  // 退出当前家庭：清除 token 和 familyId，但保留 device_id 和 device_name 方便重加入
  clearSession() {
    storage.remove(TOKEN_KEY)
    storage.remove(FAMILY_ID_KEY)
  },

  // 清除全部数据（首次初始化前未提交 device_id 的情况）
  clearAll() {
    storage.clearAll()
  },
}
